export default __webpack_public_path__ + "static/media/vat.9bcfd009.svg";